import {
  EXTERNAL_API_DELETE_EXTERNAL_API_BEGIN,
  EXTERNAL_API_DELETE_EXTERNAL_API_SUCCESS,
  EXTERNAL_API_DELETE_EXTERNAL_API_FAILURE,
  EXTERNAL_API_DELETE_EXTERNAL_API_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { getCookie, updateUserIpInCookie } from '../../../common/utils/api_utils';

export function deleteExternalApi(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: EXTERNAL_API_DELETE_EXTERNAL_API_BEGIN,
    });
    const { projectId, version, uuid } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, userIp);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.delete(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/external-api/${uuid}`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: EXTERNAL_API_DELETE_EXTERNAL_API_SUCCESS,
            data: args.uuid,
          });
          toast.success('Deleted Successfully !', {});
          resolve(res);
        },
        (err) => {
          dispatch({
            type: EXTERNAL_API_DELETE_EXTERNAL_API_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Deletion Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissDeleteExternalApiError() {
  return {
    type: EXTERNAL_API_DELETE_EXTERNAL_API_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EXTERNAL_API_DELETE_EXTERNAL_API_BEGIN:
      return {
        ...state,
        deleteExternalApiPending: true,
        deleteExternalApiError: null,
      };

    case EXTERNAL_API_DELETE_EXTERNAL_API_SUCCESS:
      return {
        ...state,
        deleteExternalApiPending: false,
        deleteExternalApiError: null,
        externalApis: state.externalApis.filter((e) => e.uuid !== action.data),
      };

    case EXTERNAL_API_DELETE_EXTERNAL_API_FAILURE:
      return {
        ...state,
        deleteExternalApiPending: false,
        deleteExternalApiError: action.data.error,
      };

    case EXTERNAL_API_DELETE_EXTERNAL_API_DISMISS_ERROR:
      return {
        ...state,
        deleteExternalApiError: null,
      };

    default:
      return state;
  }
}
